/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateUserActionLogDto } from '../../models/update-user-action-log-dto';
import { UserActionLogDto } from '../../models/user-action-log-dto';

export interface UserActionLogControllerUpdate$Params {
  id: string;
      body: UpdateUserActionLogDto
}

export function userActionLogControllerUpdate(http: HttpClient, rootUrl: string, params: UserActionLogControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<UserActionLogDto>> {
  const rb = new RequestBuilder(rootUrl, userActionLogControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserActionLogDto>;
    })
  );
}

userActionLogControllerUpdate.PATH = '/api/user-action-log/{id}';
